<template>
  <div class="active-assignment">
    <CatSubtitle :title="'common.class_assignment'" 
      :count="activeAssignments.length" 
      :routeName="'cat-assignment'"
      :eventLabel="'assignments.view_more'"
      class="cl-container"/>

    <div class=" cl-container">

      <div class="dummy-assignment" v-if="busy">
        <div class="dummy-assignment-image"></div>
        <div class="dummy-assignment-content">
          <div class="dummy-assignment-title"></div>
          <div class="dummy-assignment-subtitle"></div>        
        </div>
        <div class="dummy-assignment-date"></div>
      </div>

      <template v-else>
        <div v-if="!isActiveAssignments" class="empty-assignment">
          <img :src="'/static/images/img_empty_assignment.png'" alt="empty-assignment">
          <div class="title">{{ $t('common.empty_assignment') }}</div>
        </div>

        <Assignment v-else
          :eventLabel="'assignment'"
          :assignments="filterActiveAssginments" 
          :isBlock="false"/>

      </template>

    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import CatSubtitle from '../components/CatSubtitle';
  import Assignment from '../components/Assignment';
  
  export default {
    name: 'active-assignment',

    data() {
      return {
        busy: false,
      };
    },

    components: {
      CatSubtitle,
      Assignment,
    },

    computed: {
      ...mapGetters({
        activeAssignments: 'getActiveAssignments',
      }),

      isActiveAssignments() {
        return this.filterActiveAssginments.length !== 0;
      },

      filterActiveAssginments() {
        return this.activeAssignments.slice(0, 4) || [];
      },

    },

    methods: {
      ...mapActions([
        'fetchActiveAssignments',
      ]),
    },

    beforeMount() {
      this.busy = true;
      this.fetchActiveAssignments('active')
        .then(() => {
          this.busy = false;
        });
    },
  };
</script>

<style lang="scss" scoped>
  $dummy-background-color: rgba(0, 0, 0, 0.1);

  .active-assignment {
    background-color: #ffffff;

    .dummy-assignment {
      background-color: #ffffff;
      border-radius: 4px;
      display: inline-block;
      width: 240px;
      padding: 8px;
      margin: 8px;

      .dummy-assignment-image {
        border-radius: 4px;
        width: 100%;
        height: 120px;
        background-color: $dummy-background-color;
      }

      .dummy-assignment-content {
        padding: 14px 0px 14px 0px;
        
        .dummy-assignment-title {
          background-color: $dummy-background-color;
          padding: 4px 0px 4px 0px;
          margin: 4px 0px 4px 0px;
        }
  
        .dummy-assignment-subtitle {
          background-color: $dummy-background-color;
          padding: 4px 0px 4px 0px
        }
      }

      .dummy-assignment-date {
        background-color: $dummy-background-color;
        padding: 0px 0px 14px 0px;
      }
    }

    .empty-assignment {
      width: 128px;
      margin: 0 auto;

      img {
        width: 100px;
        height: 100px;
        margin: 14px;
      }

      .title {
        margin: 14px;
        color: #979797;
        text-align: center;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// ActiveAssignment.vue?5371567a